/**
 * Department/function options for Employees by Department filter (discover-v2).
 * API expects function ids in snake_case; labels are display-friendly.
 */
export const DEPARTMENT_FUNCTION_OPTIONS = [
  { id: "program_and_project_management", label: "Program and Project Management" },
  { id: "education", label: "Education" },
  { id: "purchasing", label: "Purchasing" },
  { id: "accounting", label: "Accounting" },
  { id: "sales", label: "Sales" },
  { id: "research", label: "Research" },
  { id: "operations", label: "Operations" },
  { id: "customer_success_and_support", label: "Customer Success and Support" },
  { id: "legal", label: "Legal" },
  { id: "product_management", label: "Product Management" },
  { id: "media_and_communication", label: "Media and Communication" },
  { id: "real_estate", label: "Real Estate" },
  { id: "quality_assurance", label: "Quality Assurance" },
  { id: "consulting", label: "Consulting" },
  { id: "arts_and_design", label: "Arts and Design" },
  { id: "healthcare_services", label: "Healthcare Services" },
  { id: "entrepreneurship", label: "Entrepreneurship" },
  { id: "engineering", label: "Engineering" },
  { id: "community_and_social_services", label: "Community and Social Services" },
  { id: "marketing", label: "Marketing" },
  { id: "information_technology", label: "Information Technology" },
  { id: "business_development", label: "Business Development" },
  { id: "administrative", label: "Administrative" },
  { id: "military_and_protective_services", label: "Military and Protective Services" },
  { id: "finance", label: "Finance" },
  { id: "human_resources", label: "Human Resources" },
  { id: "support", label: "Support" }
];

export const DEPARTMENT_ID_TO_LABEL = DEPARTMENT_FUNCTION_OPTIONS.reduce((acc, o) => {
  acc[o.id] = o.label;
  return acc;
}, {});
